import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Session from 'supertokens-web-js/recipe/session';
import ThirdPartyEmailPassword from 'supertokens-auth-react/recipe/thirdpartyemailpassword';
import apiCall from '../../utility/api';
import { GlobalContext } from '../../hooks/globalContext';
import { SkeletonHome } from '../../components/skeleton/skeletonHome';
import { shouldLoadRoute } from '../../Authentication/RouteProtection';
import { usePermissionStore } from '../../Store/permissionStore';

function useFetchData() {
	function deleteCookie(name) {
		document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
	}
	const navigate = useNavigate();
	const [hasFetched, setHasFetched] = useState(true);
	const contextValue: any = useContext(GlobalContext);
	const { permissions, setPermissions, removePermissions } = usePermissionStore();

	const loginDataProcessor = async(userDetails:any) => {
		const token = await Session.getAccessToken
		// getToken(); 
		localStorage.clear();
		sessionStorage.setItem('user-login', String(token));
		// sign in successful

		try {
			const res = await apiCall('/get-user-info', undefined, 'GET');
			// const res = await response.json();

			console.log("JWT TOKEN HERE:", res);

			if (res.message !== "unauthorised") {
				const user_email: string = res?.emails[0];
				try {
					const apiResponse = await apiCall('/users/getUsersDetails', { user_email });
					const data = apiResponse.data;

					console.log("apiData=", data);

					if (data?.length > 0) {
						userDetails = data[0];
						console.log('userDetails here: ', userDetails);

						localStorage.setItem('userDetails', JSON.stringify(userDetails));
						sessionStorage.setItem('userDetails', JSON.stringify(userDetails));

						contextValue.setUserSessionDetails({
							userId: userDetails.userid,
							userName: userDetails.firstName,
							userLName: userDetails.lastName,
							userEmail: userDetails.user_email,
							otherDetails: JSON.parse(userDetails.formDataEdit),
							rawData: userDetails,
						});
					}
				} catch (error) {
					console.error("An unexpected error occurred:", (error as Error).message);
					// setAlert(true);
				}
			}
		} catch (error) {
			console.error("Error fetching user info:", error);
		}

		try {
			const sessionResponse = await apiCall('/sessioninfo', undefined, 'GET');

			// if (!sessionResponse.ok) {
			//   throw new Error("Network response was not ok");
			// }

			// const sessionData = await sessionResponse.json();
			const sessionData = sessionResponse;
			console.log("Session info:", sessionData);
			console.log("role assigned -->", sessionData.accessTokenPayload["st-role"].v[0]);

			sessionStorage.setItem("role", sessionData.accessTokenPayload["st-role"].v[0]);

			const loadRoute = async () => {
				try {
					const [routeAllowed, permissions] = await shouldLoadRoute(
						sessionData.accessTokenPayload["st-role"].v[0]
					);
					if (routeAllowed) {
						console.log("permission===", permissions);
						setPermissions(permissions);
					} else {
						console.log("Route is not allowed.");
					}
				} catch (error) {
					console.error("Error loading route:", error);
				}
			};

			loadRoute();
		} catch (error) {
			// setIsDisabled(false);
			console.error("Error fetching session info:", error);
		}
		userDetails.userStatus == 0 ? navigate("/restricted") : navigate("/home");
	}

	//function consist of mail api call
	const sendMail = async (userEmail:string, action:string) => {
		try {
		  const response = await apiCall('/sendEmail', { userEmail, action }, "POST")
		  console.log("Success:", response);
		} catch (error) {
		  console.error("Error:", error);
		}
	  };

	  
	useEffect(() => {
		deleteCookie('sAccessToken');
		if (hasFetched) {
			console.log('useEffect triggered');
			const fetchData = async () => {
				let userDetails: any;
				try {
					const response = await ThirdPartyEmailPassword.thirdPartySignInAndUp({});
					
					if (response.status === "OK") {
						console.log(response.user)
						if (response.createdNewRecipeUser && response.user.loginMethods.length === 1) {
							// sign up successful
							//   sessionStorage.setItem('user-login',response.user.emails[0]);
							console.log('sign up successful------------------>', response);
							const email = response.user.emails[0]
							await loginDataProcessor(userDetails);
							// await sendMail(email, "PendingUserApproval"); 
							// navigate("/restricted");
							userDetails.userStatus == 0 ? navigate("/restricted") : navigate("/home");
						} else {
							console.log('sign in successful------------------>');
							await loginDataProcessor(userDetails);
							userDetails.userStatus == 0 ? navigate("/restricted") : navigate("/home");
						}
						// window.location.assign("/homepage");
					} else if (response.status === "SIGN_IN_UP_NOT_ALLOWED") {
						navigate("/");
						// this can happen due to automatic account linking. Please see our account linking docs
					} else {
						// SuperTokens requires that the third party provider
						// gives an email for the user. If that's not the case, sign up / in
						// will fail.

						// As a hack to solve this, you can override the backend functions to create a fake email for the user.

						console.log("No email provided by social login. Please use another form of login");
						// window.location.assign("/auth"); // redirect back to login page
						navigate("/");
					}
				} catch (err: any) {
					console.log('catch error: ', err);
					if (err.isSuperTokensGeneralError === true) {
						// this may be a custom error message sent from the API by you.
						navigate("/");
						console.log(err.message);
					} else {						
						console.log("Oops! Something went wrong with SSO Authentication.");
						// navigate("/");
					}
				}
			};
			fetchData();
			setHasFetched(false);
		}
	}, []);
}

const AuthCallbackView: React.FC = () => {

	// const navigate = useNavigate();

	useFetchData(); // Call the custom hook
	return (
		<>
			<SkeletonHome />
		</>
	);
};

export default AuthCallbackView;
